import QuizStep from "@/icons/ui/quiz-step.svg";
import ReceiveTreatmentStep from "@/icons/ui/receive-treatment-step.svg";
import StartTreatmentStep from "@/icons/ui/start-treatment-step.svg";
import type { StepItem } from "./types";

export type { StepItem } from "./types";

export const hiwData: StepItem[] = [
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1777975701/new_design/Frame_1171278096_1_qzoqdi.webp",
        icon: <QuizStep className="w-[110px] h-[110px] md:w-[150px] md:h-[150px]" />,
        title: "Complete our 2-minute health quiz",
        description: <>Help us understand your symptoms to see if Oestra<sup>®</sup> suits you.</>,
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1777973763/new_design/Frame_1171278096_2_y0muoi.webp",
        icon: <ReceiveTreatmentStep className="w-[110px] h-[110px] md:w-[150px] md:h-[150px]" />,
        title: "Receive your prescription treatment",
        description: "Once approved, your meds ship to your door. No visit needed.",
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1777973762/new_design/Frame_1171278096_3_e9frc7.webp",
        icon: <StartTreatmentStep className="w-[110px] h-[110px] md:w-[150px] md:h-[150px]" />,
        title: "Start treatment and get ongoing support",
        description: "Our clinical care team is always here for you whenever you want to check in.",
    },
];

export const hrtHiwData: StepItem[] = [
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1781599121/new_design/Frame_1171278096_8_stepfirst_ieds2u.webp",
        imageAlt: "Step 1: Oestra® quiz intake screen",
        icon: <QuizStep className="w-[110px] h-[110px] md:w-[150px] md:h-[150px]" />,
        title: "Complete our 2-minute health quiz",
        description: <>Help us understand your symptoms to see if Oestra<sup>®</sup> suits you.</>,
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1785313482/design_system/shipped-right_p6wp0g.webp",
        imageAlt: "Step 2: Oestra® shipped to your door",
        icon: <ReceiveTreatmentStep className="w-[110px] h-[110px] md:w-[150px] md:h-[150px]" />,
        title: "Receive your prescription treatment",
        description: "Once approved, your meds ship to your door. No visit needed.",
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1781598807/new_design/Frame_1171278096_10_hmciycyc.webp",
        imageAlt: "Step 3: Inner Balance care team",
        icon: <StartTreatmentStep className="w-[110px] h-[110px] md:w-[150px] md:h-[150px]" />,
        title: "Start treatment and get ongoing support",
        description: "Our clinical care team is always here for you whenever you want to check in.",
    },
];
